/**
 * Centralized data-testid constants for stable UI testing.
 */
export const TEST_IDS = {
  header: {
    root: "public-header",
    brand: "header-brand-link",
    navHome: "nav-home",
    navAbout: "nav-about",
    navVerification: "nav-verification",
    navCatalog: "nav-catalog",
    navGemstones: "nav-gemstones",
    navJewelry: "nav-jewelry",
    navProcess: "nav-process",
    navLegality: "nav-legality",
    navContact: "nav-contact",
    navLogin: "nav-login",
    langSwitcher: "language-switcher",
    langId: "language-option-id",
    langEn: "language-option-en",
    mobileToggle: "header-mobile-toggle",
  },
  footer: {
    root: "public-footer",
  },
  page: {
    home: "page-home",
    about: "page-about",
    verification: "page-verification",
    catalog: "page-catalog",
    gemstones: "page-gemstones",
    jewelry: "page-jewelry",
    contact: "page-contact",
    legality: "page-legality",
    login: "page-login",
    adminDashboard: "page-admin-dashboard",
    adminLegality: "page-admin-legality",
    adminSettings: "page-admin-settings",
    adminCertificates: "page-admin-certificates",
    adminCustomers: "page-admin-customers",
    adminGemstones: "page-admin-gemstones",
    adminJewelry: "page-admin-jewelry",
    adminWarranties: "page-admin-warranties",
    adminOwnership: "page-admin-ownership",
    adminMembership: "page-admin-membership",
    adminVisuals: "page-admin-visuals",
    membershipVerify: "page-membership-verify",
    notFound: "page-not-found",
  },
  common: {
    breadcrumb: "breadcrumb",
    comingSoon: "coming-soon-message",
    ctaHome: "cta-home",
    ctaVerify: "cta-verify",
    ctaPreview: "cta-preview",
    previewModal: "certificate-preview-modal",
    previewImage: "certificate-preview-image",
  },
  catalog: {
    filters: "catalog-filters",
    grid: "catalog-grid",
    sampleNotice: "catalog-sample-notice",
  },
  home: {
    heroCarousel: "hero-carousel",
    heroPrev: "hero-prev",
    heroNext: "hero-next",
    heroDots: "hero-dots",
  },
  verify: {
    section: "verification",
    form: "verify-form",
    certInput: "verify-cert-input",
    codeInput: "verify-code-input",
    submit: "verify-submit",
    result: "verify-result",
    preview: "verify-preview",
    previewImage: "verify-preview-image",
    previewFallback: "verify-preview-fallback",
    viewDigital: "verify-view-digital",
    viewerModal: "verify-viewer-modal",
    viewerClose: "verify-viewer-close",
  },
  legality: {
    page: "page-legality",
    viewer: "legality-viewer",
    ctaVerify: "legality-cta-verify",
  },
  admin: {
    layout: "admin-layout",
    sidebar: "admin-sidebar",
    navDashboard: "admin-nav-dashboard",
    navLegality: "admin-nav-legality",
    navSettings: "admin-nav-settings",
    navCertificates: "admin-nav-certificates",
    navCustomers: "admin-nav-customers",
    navGemstones: "admin-nav-gemstones",
    navJewelry: "admin-nav-jewelry",
    navWarranties: "admin-nav-warranties",
    navOwnership: "admin-nav-ownership",
    navMembership: "admin-nav-membership",
    navVisuals: "admin-nav-visuals",
    logout: "admin-logout",
    dashboard: "admin-dashboard",
    dashRefresh: "dash-refresh",
    dashMetrics: "dash-metrics",
    dashVerifyChart: "dash-verify-chart",
  },
} as const;
